import React, { FC } from 'react';
import { Spinner, SpinnerProps } from './Spinner';

export const PageSpinner: FC<SpinnerProps> = (props) => {
  return (
    <div className='flex flex-col items-center justify-center flex-1 w-full h-full' data-testid='page-spinner'>
      <Spinner {...props} />
    </div>
  );
};
